import { render, staticRenderFns } from "./DataLayerCard.vue?vue&type=template&id=50be47d7&scoped=true&"
import script from "./DataLayerCard.vue?vue&type=script&lang=js&"
export * from "./DataLayerCard.vue?vue&type=script&lang=js&"
import style0 from "./DataLayerCard.vue?vue&type=style&index=0&id=50be47d7&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be47d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50be47d7')) {
      api.createRecord('50be47d7', component.options)
    } else {
      api.reload('50be47d7', component.options)
    }
    module.hot.accept("./DataLayerCard.vue?vue&type=template&id=50be47d7&scoped=true&", function () {
      api.rerender('50be47d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/datalayers/DataLayerCard.vue"
export default component.exports